export default defineNuxtPlugin(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const partner = urlParams.get('partner');
    if (partner) {
        document.cookie = `partner_name=${partner};domain=horiz.io`
    }

    return { }
})